import { z } from 'zod';

type TFn = (key: string) => string;
const decimals = (n: number, max: number): boolean => Math.abs(n * 10 ** max - Math.round(n * 10 ** max)) < 1e-6;

/** '650,000.50' → 650000.5; anything that is not a plain positive number → null. */
export const parseMoneyInput = (raw: string): number | null => {
  const s = raw.replace(/,/g, '').trim();
  if (!/^\d+(\.\d+)?$/.test(s)) return null;
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
};

const currency = (t: TFn) => z.string().regex(/^[A-Z]{3}$/, t('targets.validation.currency'));

export const planInputSchema = (t: TFn) => z.object({
  amount: z.number().positive(t('targets.validation.positive')).refine((n) => decimals(n, 2), t('targets.validation.twoDecimals')),
  currency: currency(t),
});

export const targetInputSchema = (t: TFn) => z.object({
  target: z.number().positive(t('targets.validation.positive')).refine((n) => decimals(n, 4), t('targets.validation.fourDecimals')),
  currency: currency(t),
  effectiveFrom: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, t('targets.validation.date')),
});
